// Decision-letter drafts and PDF templates own separate parts of the letter.
// Recognize only a standalone opening greeting; never strip prose elsewhere.
const GREETING_LINE = /^(?:Dear\s+[^,\n]{1,160}|(?:Hello|Hi|Bonjour)(?:\s+[^,\n]{1,160})?|Cher(?:\/Chère)?\s+[^,\n]{1,160}|Chère\s+[^,\n]{1,160}|To whom it may concern)[,:]$/i;

function splitDecisionLetterGreeting(value) {
  let intro = String(value || '').replace(/\r\n?/g, '\n').trim();
  const firstLine = intro.split('\n')[0].trim();
  if (!GREETING_LINE.test(firstLine)) return { greeting: '', intro };
  intro = intro.slice(intro.indexOf('\n') < 0 ? intro.length : intro.indexOf('\n')).trimStart();
  // Older edited drafts may already contain the same greeting twice.
  while (intro.split('\n')[0].trim() === firstLine) {
    intro = intro.slice(intro.indexOf('\n') < 0 ? intro.length : intro.indexOf('\n')).trimStart();
  }
  return { greeting: firstLine, intro };
}

function resolveDecisionLetterGreeting(draft = {}, recipientName = '') {
  const split = splitDecisionLetterGreeting(draft.decision_intro);
  const greeting = String(draft.decision_greeting || '').trim() || split.greeting ||
    (String(recipientName || '').trim() ? `Dear ${String(recipientName).trim()},` : '');
  return { greeting, intro: split.intro };
}

// Adapt the existing template's greeting slot at render time. Authoring rows
// and already-resolved/signed schemas are never rewritten by this helper.
function prepareDecisionLetterTemplate(value) {
  if (typeof value !== 'string') return value;
  const prepared = value.replace(
    /\b(?:Dear|Cher|Chère|Cher\/Chère|Bonjour|Hello)[ \t]+\{\{\s*applicant_(?:name|full_name|salutation_name)\s*\}\},/g,
    '{{decision_greeting}}'
  );
  return prepared;
}

module.exports = {
  splitDecisionLetterGreeting,
  resolveDecisionLetterGreeting,
  prepareDecisionLetterTemplate,
};
